import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Manager, Reference, Popper } from 'react-popper';
import Portal from '@reach/portal';

import styles from './styles.scss';

const Tooltip = ({ label, children, position, className, offset }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleShow = () => {
    setIsOpen(true);
  };

  const handleHide = () => {
    setIsOpen(false);
  };

  const tooltipClassName = () => {
    const toolTipClasses = [styles.tooltip];

    if (className) {
      toolTipClasses.push(className);
    }

    return toolTipClasses.join(' ');
  };

  return (
    <Manager>
      <Reference>
        {({ ref }) =>
          React.cloneElement(
            typeof children === 'string' ? <span>{children}</span> : children,
            {
              ref,
              onMouseOver: handleShow,
              onMouseLeave: handleHide,
              onFocus: handleShow,
              onBlur: handleHide
            }
          )
        }
      </Reference>

      {isOpen && (
        <Portal>
          <Popper
            placement={position}
            modifiers={[
              {
                name: 'offset',
                options: {
                  offset: [0, offset]
                }
              }
            ]}
          >
            {({ style, placement: dataPlacement, ref, arrowProps }) => (
              <div
                ref={ref}
                role="tooltip"
                style={style}
                className={tooltipClassName()}
                data-placement={dataPlacement}
              >
                <div className={styles.label}>{label}</div>
                <div
                  ref={arrowProps.ref}
                  style={arrowProps.style}
                  className={styles.arrow}
                  data-placement={dataPlacement}
                />
              </div>
            )}
          </Popper>
        </Portal>
      )}
    </Manager>
  );
};

Tooltip.defaultProps = {
  position: 'bottom',
  className: null,
  offset: 0
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  className: PropTypes.string,
  offset: PropTypes.number
};

export default Tooltip;
